import { render, staticRenderFns } from "./WorkTab.vue?vue&type=template&id=3d67d6a6"
import script from "./WorkTab.vue?vue&type=script&lang=js"
export * from "./WorkTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports